export default "__VITE_ASSET__DvC1PMyz__"